import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import { openProtectedFile } from '../../services/api';

// Enlaces a los documentos opcionales que adjunta el conductor en el
// preoperacional (orden de trabajo, aptitud física). Los archivos exigen
// sesión NOVA, por eso se abren con openProtectedFile y no con <a href>.
export default function PreopDocumentLinks({ documents, variant = 'list' }) {
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');
  const docs = Array.isArray(documents) ? documents.filter((d) => d && d.url) : [];
  if (docs.length === 0) return null;

  const open = async (doc) => {
    setError('');
    setBusyId(doc.id);
    try {
      await openProtectedFile(doc.url);
    } catch (e) {
      setError(e?.message || 'No fue posible abrir el documento.');
    } finally {
      setBusyId(null);
    }
  };

  const cls = variant === 'panel'
    ? 'mt-2 flex items-center gap-1.5 text-xs font-semibold text-blue-700 hover:text-blue-800'
    : 'mt-1 flex items-center gap-1 text-xs font-medium text-blue-600 hover:text-blue-900';

  return (
    <div>
      {docs.map((doc) => (
        <button
          key={doc.id}
          type="button"
          onClick={() => open(doc)}
          disabled={busyId === doc.id}
          className={`${cls} disabled:opacity-60`}
          title={doc.name || doc.label}
        >
          <FileText size={14} />
          {busyId === doc.id ? 'Abriendo…' : `Ver ${doc.type === 'ORDEN_TRABAJO' ? 'orden de trabajo (OT)' : 'aptitud física'}`}
        </button>
      ))}
      {error && <div className="mt-1 text-xs text-red-600">{error}</div>}
    </div>
  );
}
